import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueTheMask from "vue-the-mask";

import "plyr/dist/plyr.css";

import "element-ui/lib/theme-chalk/index.css";
import lang from "element-ui/lib/locale/lang/pt";
import locale from "element-ui/lib/locale";

import "./assets/scss/app.scss";
import "./components";
import "./plugins";
import { init } from "./setup/api";

import VueSocialSharing from "vue-social-sharing";

locale.use(lang);

Vue.use(VueTheMask);
Vue.use(VueSocialSharing);
Vue.use(BootstrapVue);

init();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

window.openSupport = function() {
  const iframes = window.document.getElementsByTagName("iframe");
  for (let i in iframes) {
    const button = iframes[i].contentDocument
      ? iframes[i].contentDocument.getElementsByClassName("u-isActionable")
      : false;
    if (button && button.length) {
      button[0].click();
    }
  }
};
